/**
 * @author        nico@zumper.com (Nico Rattazzi)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   All routes for djz (from zumper_code/zumper/www/djp/frontend/app_urls.py)
 */

import loadable from '@loadable/component'
import { routes } from '@zcode/zumper-routes'

// app routes
const Homepage = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "Homepage" */ '../components/Homepage/HomepageContainer')
  ),
}

const HomepageZumperRentals = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "HomepageZumperRentals" */ '../components/HomepageZumperRentals/HomepageZumperRentalsContainer'
      )
  ),
}

const NearMe = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "NearMe" */ '../components/NearMe/NearMeContainer')
  ),
}

const FullDetailView = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "FullDetailView" */ '../components/detail/FullDetailView/FullDetailViewContainer'
      )
  ),
}

const PermanentAddress = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "PermanentAddress" */ '../pages/PageAddress/PageAddressContainer')
  ),
}

const ForYou = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "ForYou" */ '../components/ForYou/ForYouContainer')
  ),
}

const CurrentSearchRoute = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "CurrentSearchRoute" */ '../components/CurrentSearchRoute/CurrentSearchRouteContainer'
      )
  ),
}

const FavoritesRoute = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "FavoritesRoute" */ '../components/Favorites/FavoritesRoute')
  ),
}

const MessagedRoute = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "MessagedRoute" */ '../components/Messaged/MessagedRoute')
  ),
}
const PageMessages = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "PageMessages" */ '../pages/PageMessages/PageMessagesContainer')
  ),
}

const SavedSearchesRoute = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SavedSearchesRoute" */ '../components/SavedSearches/SavedSearchesRoute'
      )
  ),
}

const SavedSearchesSummaryRoute = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SavedSearchesSummaryRoute" */ '../components/SavedSearches/SavedSearchesSummaryRoute'
      )
  ),
}

const NewsroomPage = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "NewsroomPage" */ '../components/Newsroom')
  ),
}

const AboutLanding = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "AboutPageLanding" */ '../components/UpdatedAboutPage/AboutLanding/AboutLandingContainer'
      )
  ),
}

const ZumperRentalsAboutPage = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "ZumperRentalsAboutPage" */ '../components/ZumperRentalsAboutPage/ZumperRentalsAboutPage'
      )
  ),
}

const StrLanding = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "StrPageLanding" */ '../components/StrLanding/StrLandingContainer'
      )
  ),
}

const STRProviderInterstitial = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "StrPageLanding" */ '../components/main/Rail/STRProviderInterstitial'
      )
  ),
}

const CareersPage = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "CareersPage" */ '../components/CareersPage')
  ),
}

const NotificationSettings = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "NotificationSettings" */ '../components/notification_settings')
  ),
}

const RentResearchDetail = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "RentResearchDetail" */ '../pages/PageRentResearchDetail/PageRentResearchDetailContainer'
      )
  ),
}

const RentResearchHomepage = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "RentResearchHomepage" */ '../pages/PageRentResearchHomepage/PageRentResearchHomepageContainer'
      )
  ),
}

const TransunionTOS = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "TransunionTOS" */ '../components/TransunionTOS')
  ),
}

const CcpaConfirmationPage = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "Ccpa" */ '../components/Ccpa/Confirmation/ConfirmationPageContainer'
      )
  ),
}

const CcpaRequestPage = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "Ccpa" */ '../components/Ccpa/Request/RequestPageContainer')
  ),
}

const FairHousing = {
  lazy: true,
  component: loadable(
    () => import(/* webpackChunkName: "FairHousing" */ '../components/FairHousing/FairHousing')
  ),
}

const PrivacyPolicy = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "PrivacyPolicy" */ '../components/PrivacyPolicy/PrivacyPolicy')
  ),
}
const PrivacyPolicy102022 = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "PrivacyPolicy-10-2022" */ '../components/PrivacyPolicy/archived/PrivacyPolicy-10.2022'
      )
  ),
}

const SitemapChildPage = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SitemapChildPage" */ '../pages/PageSitemap/PageSitemapChildPage/PageSitemapChildPageContainer'
      )
  ),
}

const SitemapEntryPoint = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SitemapEntryPoint" */ '../pages/PageSitemap/PageSitemapEntryPoint/PageSitemapEntryPointContainer'
      )
  ),
}

const ZumperAccount = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "ZumperAccount" */ '../pages/PageZumperAccount/PageZumperAccount')
  ),
}

const TermsAndConditions = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "TermsAndConditions" */ '../components/TermsAndConditions/TermsAndConditions'
      )
  ),
}

const CommunityListingsTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "CommunityListingsTerms" */ '../components/CommunityListingsTerms/CommunityListingsTerms'
      )
  ),
}

const SignatureVirtualTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SignatureVirtualTerms" */ '../components/CommunityListingsTerms/SignatureVirtualTerms'
      )
  ),
}

const SnapprTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "SnapprTerms" */ '../components/CommunityListingsTerms/SnapprTerms'
      )
  ),
}

const ReviewsTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "ReviewsTerms" */ '../components/CommunityListingsTerms/ReviewsTerms'
      )
  ),
}

const NurtureBossTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "NurtureBossTerms" */ '../components/CommunityListingsTerms/NurtureBossTerms'
      )
  ),
}

const GooglePostingServicesTerms = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "GooglePostingServicesTerms" */ '../components/CommunityListingsTerms/GooglePostingServicesTerms'
      )
  ),
}

const AffordabilityCalculator = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "AffordabilityCalculator" */ '../components/AffordabilityCalculator'
      )
  ),
}

const VirtualToursPage = {
  lazy: true,
  component: loadable(
    () =>
      import(
        /* webpackChunkName: "VirtualToursPage" */ '../components/VirtualToursPage/VirtualToursPageContainer'
      )
  ),
}

const AIAssistant = {
  lazy: true,
  component: loadable(
    () =>
      import(/* webpackChunkName: "AIAssistant" */ '../components/AIAssistant/AIAssistantContainer')
  ),
}

export const routeComponents = {
  Homepage,
  HomepageZumperRentals,
  NearMe,
  ForYou,
  FullDetailView,
  // mainApp
  CurrentSearchRoute,
  FavoritesRoute,
  MessagedRoute,
  SavedSearchesRoute,
  SavedSearchesSummaryRoute,
  // other
  AboutLanding,
  AIAssistant,
  StrLanding,
  AffordabilityCalculator,
  CareersPage,
  CcpaConfirmationPage,
  CcpaRequestPage,
  CommunityListingsTerms,
  FairHousing,
  GooglePostingServicesTerms,
  PageMessages,
  NewsroomPage,
  NotificationSettings,
  NurtureBossTerms,
  PermanentAddress,
  PrivacyPolicy,
  PrivacyPolicy102022,
  RentResearchDetail,
  RentResearchHomepage,
  ReviewsTerms,
  SignatureVirtualTerms,
  SitemapChildPage,
  SitemapEntryPoint,
  SnapprTerms,
  STRProviderInterstitial,
  TransunionTOS,
  TermsAndConditions,
  VirtualToursPage,
  ZumperAccount,
  ZumperRentalsAboutPage,
}

/**
 *
 * @param {import('@zcode/router-utils').ZumperRoute} route
 * @returns {import('@zcode/router-utils').ZumperRoute}
 */
const zipRoutes = (route) => ({
  ...route,
  ...routeComponents[route.name],
  routes: Array.isArray(route.routes) ? route.routes.map(zipRoutes) : undefined,
})

// NOTE: Here we zip the route components together with the route definitions.
// If you want to match against the routes but do not want to inadvertently
// import every route component for the whole site, import the route definitions
// instead.
export default routes.map(zipRoutes)
